import { render, staticRenderFns } from "./submission-responses-panel.vue?vue&type=template&id=3ab45631&scoped=true&"
import script from "./submission-responses-panel.vue?vue&type=script&lang=ts&"
export * from "./submission-responses-panel.vue?vue&type=script&lang=ts&"
import style0 from "./submission-responses-panel.vue?vue&type=style&index=0&id=3ab45631&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab45631",
  null
  
)

export default component.exports